var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger",on:{"click":_vm.toggleClick}},[_c('i',{staticClass:"a-c-second",class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }